import React from 'react';
import { useTenantStore } from '../stores/TenantStore';
import { Box, Zoom } from '@mui/material';
import AppContainer from './layout/AppContainer';
import IFrame from './shared/IFrame';
import CloseButton from './shared/CloseButton';


const EmbeddedUrlViewer = ({ isModal }: { isModal: boolean }) => {
  const { tenant, activeState, updateActiveState, setIsRequestPending } = useTenantStore();
  const handleCloseEmbeddedUrlViewer = () => {
    updateActiveState('emptyResponse')
    setIsRequestPending(true)
  }
  const handleContainerClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      handleCloseEmbeddedUrlViewer()
    }
  };

  const closeButtonStyle = isModal ? { top: 6, left: 6, boxShadow: "none" } : { bottom: 24, right: 24 }

  const content = (
    <Box display="flex" flexDirection="column" height="calc(100vh - 8rem)" width="100%" position="relative" top={0}>
      <IFrame
        src={(tenant.urlInfo && tenant.urlInfo.url) || ""}
      />
      <Zoom in={activeState.embeddedHasArrived} timeout={500} style={{
        transitionDelay: activeState.embeddedHasArrived ? '500ms' : '0ms',
      }}
        unmountOnExit>
        <Box style={{ position: "absolute", top: 5, left: 5 }}>
          <CloseButton onClick={handleCloseEmbeddedUrlViewer} />
        </Box>
      </Zoom>
    </Box>
  )
  return (
    isModal ?
      <div onClick={handleContainerClick}>
        {content}
      </div> :
      <AppContainer>
        {content}
      </AppContainer>
  );
};
export default EmbeddedUrlViewer;